/** GIS upload documentType labels (quotation upload API). */
export const MOTOR_DOC_NAMES = {
  logbook: 'Log Book',
  kra: 'KRA PIN',
  nationalId: 'National ID',
};

export const MOTOR_UPLOAD_ACCEPT = ['application/pdf', 'image/jpeg', 'image/png'];
export const MOTOR_UPLOAD_MAX_BYTES = 6 * 1024 * 1024;
